import { useEffect, useState } from "react"
import QRCode from "qrcode"
import { useTheme } from "../theme/ThemeProvider"

type QRProps = {
  value: string
  size?: number
}

export function QR({ value, size = 140 }: QRProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null)
  const { theme } = useTheme()
  const darkColor = theme === "fairy" ? "#0c3d32" : "#ff2b4f"
  const lightColor = theme === "fairy" ? "#ffffff" : "#0a0a0b"

  useEffect(() => {
    let mounted = true
    if (!value) {
      setDataUrl(null)
      return () => {
        mounted = false
      }
    }

    QRCode.toDataURL(value, {
      margin: 1,
      scale: 8,
      color: { dark: darkColor, light: lightColor },
    })
      .then((url) => {
        if (mounted) setDataUrl(url)
      })
      .catch(() => {
        if (mounted) setDataUrl(null)
      })

    return () => {
      mounted = false
    }
  }, [value, darkColor, lightColor])

  return (
    <div
      style={{
        width: size,
        height: size,
        border: "2px solid var(--rail)",
        display: "grid",
        placeItems: "center",
        background: "var(--panel)",
      }}
    >
      {dataUrl ? (
        <img src={dataUrl} alt="qr" style={{ width: size - 20, height: size - 20 }} />
      ) : (
        <span className="small" style={{ color: "var(--muted)" }}>
          loading…
        </span>
      )}
    </div>
  )
}

export default QR
